import GameState from "./game-state";
import { CheckLinkState } from "./check-link-state";
import { IGame } from "../types/game";

/**
 * PlayerAddBonusState - Adds garbage lines one at a time with animation
 * This state is triggered when canvas.bonus > 0 (there are pending garbage lines)
 * It adds one line every 7 frames, matching the original C++ implementation
 */
export default class PlayerAddBonusState extends GameState {
  private anim: number = 0;
  private firstDone: boolean = false;
  private nb: number = 0;

  constructor(game: IGame) {
    super(game);

    this.nb = this.canvas.bonus;
    this.anim = 0;
    this.firstDone = false;

    if (this.game.audioManager) {
      try {
        this.game.audioManager.playSound("bonus1");
      } catch (e) {}
    }
  }

  enter(): void {}

  update(frameTime: number): void {
    super.update(frameTime);

    if (!this.nb || this.nb === 0) {
        if (this.canvas.bonus > 0) {
          this.nb = this.canvas.bonus;
        }
    }

    if (this.nb > 0 && this.canvas.bonus > 0) {
      if (this.anim === 0) {
        for (let j = 0; j < 31; j++) {
          for (let i = 4; i < 14; i++) {
            this.canvas.blocks[j][i] = this.canvas.blocks[j + 1][i];
            this.canvas.occupied[j][i] = this.canvas.occupied[j + 1][i];
            this.canvas.blinded[j][i] = this.canvas.blinded[j + 1][i];
            this.canvas.bflash[j][i] = this.canvas.bflash[j + 1][i];
            this.canvas.dirted[j + 1][i] = 2;
          }
        }

        let holePos = this.canvas.bon[0].hole_pos;

        let topBottomAdd = 0;
        if (!this.firstDone) {
          topBottomAdd |= 2;
        }
        if (this.canvas.bon[0].final) {
          topBottomAdd |= 8;
        }

        for (let i = 4; i < 14; i++) {
          this.canvas.blocks[31][i] =
            topBottomAdd + (this.canvas.bon[0].color << 4);
          this.canvas.occupied[31][i] = true;
        }

        let holePosCopy = holePos;
        for (let i = 4; i < 14; i++) {
          if (holePosCopy & 512) {
            this.canvas.blocks[31][i] = 0;
            this.canvas.occupied[31][i] = false;

            if (this.firstDone && this.canvas.occupied[30][i]) {
              this.canvas.blocks[30][i] |= 8;
            }
            if (i > 4) {
              if (this.canvas.occupied[31][i - 1]) {
                this.canvas.blocks[31][i - 1] |= 4;
              }
              if (this.canvas.occupied[31][4]) {
                this.canvas.blocks[31][4] |= 1;
              }
            }
            if (i < 14) {
              this.canvas.blocks[31][i + 1] |= 1;
              this.canvas.blocks[31][14] |= 4;
            }
          } else {
            if (this.firstDone && !this.canvas.occupied[30][i]) {
              this.canvas.blocks[31][i] |= 2;
            }
          }
          this.canvas.blinded[31][i] = 0;
          this.canvas.bflash[31][i] = 0;
          holePosCopy <<= 1;
        }

        this.firstDone = true;
        if (this.canvas.bon[0].final) {
          this.firstDone = false;
        }
      }

      this.anim++;
      if (this.anim === 7) {
        for (let y = 1; y < this.canvas.bonus; y++) {
          this.canvas.bon[y - 1] = this.canvas.bon[y];
        }
        this.canvas.bonus--;
        this.nb--;
        this.anim = 0;
      }
    } else {
      for (let i = 4; i < 14; i++) {
        if (this.canvas.occupied[0] && this.canvas.occupied[0][i]) {
          this.canvas.blocks[0][i] |= 2;
        }
      }

      this.canvas.clearTmp();

      this.game.pushState(new CheckLinkState(this.game));

      this.game.popState(this);
    }
  }

  toString(): string {
    return "Add Bonus";
  }
}
